










import {Component, Vue} from 'vue-property-decorator';
import FacebookPixelForm from '@/screens/dashboard/facebookpixel/FacebookPixelForm.vue';

@Component({
  components: {
    FacebookPixelForm
  }
})
export default class NewSupplierScreen extends Vue {

}
